// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { appReducer } from 'store/behaviors/loader';
import capabilities from './capabilities';
import initialState from './grid';

const slice = createSlice({
    name: 'tplFollowUp',
    initialState,
    reducers: {
        ...appReducer(capabilities),
        insertSteps(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, steps } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item) return;

            item.steps = [...(Array.isArray(item.steps) ? item.steps : []), ...[].concat(steps || [])];
        },
        updateSteps(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, steps } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item) return;

            if (!Array.isArray(item.steps)) {
                item.steps = [];
            }

            [].concat(steps || []).forEach((updStep) => {
                if (!updStep?.id) return;

                const stepIndex = item.steps.findIndex((step) => step.id === updStep.id);

                if (stepIndex === -1) {
                    item.steps.push(updStep);
                } else {
                    item.steps[stepIndex] = {
                        ...item.steps[stepIndex],
                        ...updStep
                    };
                }
            });
        },
        deleteSteps(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, steps } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item || !Array.isArray(item.steps)) return;

            const idsToDelete = new Set(
                []
                    .concat(steps || [])
                    .filter(Boolean)
                    .map((step) => step.id)
            );

            item.steps = item.steps.filter((step) => !idsToDelete.has(step.id));
        }
    }
});

export default slice.reducer;

export const tplFollowUpActions = slice.actions;
